
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 114.389 15.375","height":"58.111","width":"432.338"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-2.525 -66.79)"}},[_c('ellipse',{attrs:{"ry":"4.441","rx":"57.195","cy":"77.724","cx":"59.72","opacity":".1","fill":"#6c63ff"}}),_c('path',{attrs:{"fill":"#d0d2d5","d":"M47.493 76.935l1.16-10.145H69.71l1.55 10.145.119.769.023.153-23.98-.307z"}}),_c('path',{attrs:{"opacity":".1","d":"M71.38 77.704H59.412l-11.99-.154.07-.615h23.77z"}}),_c('path',{attrs:{"fill":"#d0d2d5","d":"M43.426 77.089h31.82v.768h-31.82z"}}),_c('path',{attrs:{"opacity":".1","d":"M69.817 67.481H61.72l9.567 9.608z"}})])])
          )
        }
      }
    